<!--
 * IMPORTANT:
 * This file is used in both vue2 and vue3 application
 * Make sure to check both versions while making changes to this file
 * Don't use store or vue syntax in this file
 * for any clarification contact Avaneesh
 -->
<script>
import axios from 'axios';

export default {
  data() {
    return {
      dealerLocations: [],
      gridColumns: window.menuStyleId !== '15' ? 'col-6 col-md-4 col-xxl-3' : 'col-6 col-xxl-4'
    };
  },
  methods: {
    getDealerInventoryURL(siteURL) {
      if (!siteURL) return '#';

      const normalizedURL = siteURL.startsWith('http') ? siteURL : `https://${siteURL}`;
      return `${normalizedURL}/inventory/new`;
    },
    getGroupDealersLocations() {
      let url = `${window.ApiBaseUrl}/DealerGroup/GetAllDealerDetails?campaignid=${window.campaignId}`;
      axios.get(url)
      .then(response => {
        this.dealerLocations = response.data || [];
      })
      .catch(error => {
        console.error('Error fetching dealer locations:', error);
      });
    }
  },
  mounted() {
    this.getGroupDealersLocations();
  }
};
</script>

<template>
<div class="m-locations-container p-4">
  <div class="m-locations-wrapper container-fluid bg-white h-100">
    <div v-if="dealerLocations.length" class="row p-3">
      <div v-for="(dealer, index) in dealerLocations" :key="index" :class="['px-3 py-4', gridColumns]">
        <div class="dealer-location-card d-flex align-items-center flex-row">
          <div class="logo-container" :class="{ 'dealer-has-logo' : dealer.themeLogoUrl }">
            <img v-if="dealer.themeLogoUrl" :src="dealer.themeLogoUrl" :alt="dealer.clientName" class="img-fluid" />
          </div>
          <div class="dealer-location-info">
            <p class="font-weight-bold _theme_font_bold mb-0">{{ dealer.clientName }}</p>
            <p class="mb-1">{{ dealer.fullAddress }}</p>
            <a :href="getDealerInventoryURL(dealer.siteURL)" target="_blank" class="color-primary dealer-inventory-link">View Inventory</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.m-locations-container {
  border-radius: 25px;
  background-color: #F3F3F3;
}
.m-locations-wrapper {
  overflow: scroll;
}
.dealer-location-card {
  gap: 15px;
}
.logo-container {
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  border-radius: 50%;
  height: 60px;
  width: 60px;
}
.logo-container img {
  max-width: 50px;
}
.dealer-has-logo {
  background-color: #F3F3F3;
}
.dealer-location-info {
  font-size: 14px;
}
.dealer-inventory-link {
  text-decoration: underline;
}
</style>
